import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgCelo = function SvgCelo(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#FCFE53",
        d: "M60 0C26.863 0 0 26.863 0 60s26.863 60 60 60 60-26.863 60-60S93.137 0 60 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M90 30H30v60h60V69.055h-9.963C76.606 76.7 68.882 82.01 60.047 82.01c-12.188 0-22.057-9.963-22.057-22.057-.016-12.094 9.869-21.963 22.057-21.963 9.008 0 16.731 5.483 20.162 13.3H90z"
    })));
};

export { SvgCelo as ReactComponent };
//# sourceMappingURL=CELO.svg.es.js.map
